import React, { memo } from 'react';
import Link from 'next/link';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import ButtonLink from '@mui/material/Link';

import { IProps } from './model';
import { SocialNetWorks } from '../../../social-networks';
import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';

import { LoginButtonOrUser } from './components/login-button-user';
import { SocialNetWorksContainer, StyledLinkItem } from '../../styles';
import { CollapsibleMenuItem } from '@mais-retorno-front/components/collapsible-menu-item';

import {
  CONTENT_OPTION_MENU,
  TOOLS_OPTION_MENU,
  MAIS_RETORNO_MENU,
  SHEET_OPTIONS,
  LIST_OPTION_MENU,
  PRODUCTS_MENU,
} from '../../constants/menu-options.constant';

import { CollapsibleMenuProductItem } from '@mais-retorno-front/components/collapsible-menu-producct-item';
import { useAuth } from '@core/features-core/auth/client';
import { RedirectToolButton } from '@mais-retorno-front/components/redirect-tool-button';
import { UTMContent } from '@mais-retorno-front/components/utm-button/enum';

export const DrawerContent = memo<IProps>(({ setOpenDrawer }) => {
  const handleClose = () => setOpenDrawer(false);
  const { userIsPremium, userIsPro } = useAuth();

  return (
    <>
      <List>
        <LoginButtonOrUser />

        <ListItem>
          <RedirectToolButton
            utmContent={UTMContent.CTA_MOBILE_NAVBAR}
            userIsPremium={userIsPremium}
            userIsPro={userIsPro}
            textVariant="navbar"
            size="small"
          />
        </ListItem>

        <li>
          <Link href="/" passHref legacyBehavior prefetch={false}>
            <StyledLinkItem
              title="Home"
              target="_blank"
              onClick={handleClose}
              component={ButtonLink}
              color="inherit"
            >
              <ListItemText primary="Home" />
            </StyledLinkItem>
          </Link>
        </li>

        <CollapsibleMenuItem
          title={TOOLS_OPTION_MENU.title}
          items={[...TOOLS_OPTION_MENU.items, ...LIST_OPTION_MENU.items]}
          closeDrawer={handleClose}
        />

        <CollapsibleMenuProductItem
          items={PRODUCTS_MENU.items}
          title={PRODUCTS_MENU.title}
          closeDrawer={handleClose}
        />

        <CollapsibleMenuItem
          items={CONTENT_OPTION_MENU.items}
          title={CONTENT_OPTION_MENU.title}
          closeDrawer={handleClose}
        />

        <CollapsibleMenuItem
          items={SHEET_OPTIONS.subItems}
          title={SHEET_OPTIONS.label}
          closeDrawer={handleClose}
        />

        <CollapsibleMenuItem
          items={MAIS_RETORNO_MENU.items}
          title={MAIS_RETORNO_MENU.title}
          closeDrawer={handleClose}
        />

        <li>
          <StyledLinkItem
            href={DEFAULT_ROUTES.privacyPolicy}
            title="Política de privacidade"
            target="_blank"
            onClick={handleClose}
            component={ButtonLink}
            color="inherit"
          >
            <ListItemText primary="Política de privacidade" />
          </StyledLinkItem>
        </li>
      </List>
      <SocialNetWorksContainer>
        <Typography
          component="p"
          variant="body2"
          align="center"
          style={{ fontWeight: 700 }}
        >
          Siga nossas redes
        </Typography>

        <SocialNetWorks />
      </SocialNetWorksContainer>
    </>
  );
});
